import { PLUGINS_COLUMN_ID } from "../constants";
import PluginsTableActionsCell from "./ActionsCell";
import PluginsTableCreatedAtCell from "./CreatedAtCell";
import PluginsTableDescriptionCell from "./DescriptionCell";
import PluginsTableLabelIdentifierCell from "./LabelIdentifierCell";
import PluginsTableLabelsCell from "./LabelsCell";
import PluginsTableNameCell from "./NameCell";
import PluginsTableSpaceCell from "./SpaceCell";

export const pluginsTableCells = {
  [PLUGINS_COLUMN_ID.NAME]: PluginsTableNameCell,
  [PLUGINS_COLUMN_ID.LABELS]: PluginsTableLabelsCell,
  [PLUGINS_COLUMN_ID.DESCRIPTION]: PluginsTableDescriptionCell,
  [PLUGINS_COLUMN_ID.LABEL_IDENTIFIER]: PluginsTableLabelIdentifierCell,
  [PLUGINS_COLUMN_ID.SPACE]: PluginsTableSpaceCell,
  [PLUGINS_COLUMN_ID.CREATED_AT]: PluginsTableCreatedAtCell,
  [PLUGINS_COLUMN_ID.DROPDOWN]: PluginsTableActionsCell,
};
